import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { formatDateTime, formatJson } from './streakAuditUtils';

function StreakAuditLogTable({ entries }) {
  const [expandedRows, setExpandedRows] = useState({});

  if (!entries?.length) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
        No audit entries found.
      </Typography>
    );
  }

  const toggleRow = (id) => {
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow sx={{ bgcolor: '#fafafa' }}>
            <TableCell sx={{ width: 40 }} />
            <TableCell sx={{ fontWeight: 700 }}>When</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Local date</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Decision</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Previous → New</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Reason</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>UUID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries.map((entry) => {
            const isExpanded = Boolean(expandedRows[entry.id]);
            const meta = entry.metadata || {};

            return (
              <React.Fragment key={entry.id}>
                <TableRow hover sx={{ '& > td': { borderBottom: isExpanded ? 0 : undefined } }}>
                  <TableCell>
                    <IconButton size="small" onClick={() => toggleRow(entry.id)}>
                      {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                  </TableCell>
                  <TableCell>{formatDateTime(entry.created_at)}</TableCell>
                  <TableCell>{meta.localDate || '—'}</TableCell>
                  <TableCell>{entry.decision}</TableCell>
                  <TableCell>
                    {meta.previousStreak != null && meta.newStreak != null
                      ? `${meta.previousStreak} → ${meta.newStreak}`
                      : '—'}
                  </TableCell>
                  <TableCell sx={{ maxWidth: 280 }}>
                    <Typography variant="body2" noWrap title={entry.reason || ''}>
                      {entry.reason || '—'}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="caption" sx={{ fontFamily: 'monospace' }}>
                      {entry.uuid ? `${entry.uuid.slice(0, 8)}…` : '—'}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell colSpan={7} sx={{ py: 0 }}>
                    <Collapse in={isExpanded}>
                      <Paper variant="outlined" sx={{ m: 1, p: 1, bgcolor: '#fafafa' }}>
                        <Typography variant="caption" color="text.secondary">Full metadata</Typography>
                        <Typography component="pre" variant="caption" sx={{ m: 0, whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
                          {formatJson(entry.metadata)}
                        </Typography>
                      </Paper>
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default StreakAuditLogTable;
